import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider } from 'firebase/auth';
import {
  connectFirestoreEmulator,
  initializeFirestore,
} from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { buildFirebaseConfig } from '../../services/firebaseConfig';

/** Platform-owned Firebase client handles. */
const firebaseConfig = buildFirebaseConfig(
  process.env,
  typeof window !== 'undefined' ? window.location.hostname : undefined,
);

const useEmulators = typeof window !== 'undefined' && window.location.hostname === 'localhost';
const FIRESTORE_DATABASE_ID = useEmulators ? '(default)' : 'default';

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(
  app,
  useEmulators ? { experimentalForceLongPolling: true } : {},
  FIRESTORE_DATABASE_ID,
);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();

if (useEmulators) {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8090);
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
